<template>
  <div>
    <data-table
      ref="tabelaProdutos"
      api-route="/produtos/"
      item-key="codproduto"
      :columns="columns"
      :filters="filters"
      sort-by="codproduto"
      :sort-desc="true"
    />
    <FloatBtn text="Cadastrar Produto" @click="abrirDialogProduto()" />
    <CadastroProdutoDialog
      v-model="dialogProduto"
      :produto="produtoSelecionado"
      @produto-cadastrado="recarregarTabela"
    />
  </div>
</template>

<script>
import DataTable from './comum/DataTable.vue';
import FloatBtn from './FloatBtn.vue';
import CadastroProdutoDialog from './CadastroProdutoDialog.vue';

export default {
  components: {
    DataTable,
    FloatBtn,
    CadastroProdutoDialog,
  },
  data() {
    return {
      dialogProduto: false,
      produtoSelecionado: null,
      columns: [
        { key: 'codproduto', title: 'Cód. Produto' },
        { key: 'nome', title: 'Nome' },
        { key: 'descricao', title: 'Descrição' },
      ],
      filters: [
        { model: 'nome', label: 'Filtrar por Nome', icon: 'mdi-magnify' },
        { model: 'codproduto', label: 'Filtrar por Código do Produto', type: 'number', icon: 'mdi-numeric' },
      ],
    };
  },
  methods: {
    abrirDialogProduto() {
      this.dialogProduto = true;
    },
    recarregarTabela() {
      this.$refs.tabelaProdutos.recarregar();
    }
  },
};
</script>
